module.exports = __webpack_public_path__ + "static/img/logo.0d9a15c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live/logo.png
// module id = tFiE
// module chunks = 1